import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsTermSelectorComponent } from "./ds-term-selector.component";
import { DsTermChipModule } from "../ds-term-chip/ds-term-chip.module";

@NgModule({
  declarations: [DsTermSelectorComponent],
  imports: [CommonModule, DsTermChipModule],
  exports: [DsTermSelectorComponent, DsTermChipModule],
})
export class DsTermSelectorModule {}
